import { environment } from '@env/environment';

const { apiUrl } = environment;

/**
 * ### **DashboardEndpoint **
 *
 * Los endpoints son las URLs de un API o un backend que responden a una petición, en este caso las relacionadas a dashboard
 */
export class DashboardEndpoint {
  static bookableServices = `${apiUrl}bookable_services/data`;
  static servicesGrouper = `${apiUrl}bookable_services/api_services_grouper/?types_bookable_service={}`;
  static accomodationTypes = `${apiUrl}types_accommodation/data/?id={}&active={}`;
  static variants = `${apiUrl}variants/data/`;
  static sidebarDashboardVariants = `${apiUrl}variants/sidebar_dashboard_variants/`;
}
